var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('h3',{staticClass:"font-weight-light",staticStyle:{"color":"#0e5082","text-align":"center"}},[_vm._v("PX Data")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }